<template>
  <div class="c-list-box" style="padding: 0">
    <ul class="c-list-nav">
      <li class="c-list-title">附表填写</li>
      <li v-if="state.selectIds?.length > 0" style="margin-right: 20px">
        已选择<strong style="margin: 0 5px; color: #1e90ff; font-size: 120%">{{
          state.selectIds?.length
        }}</strong
        >条数据
      </li>
      <el-button
        type="warning"
        :icon="Edit"
        :disabled="!state.selectIds?.length > 0"
        link
        @click="state.showEdits = true"
        >批量编辑
      </el-button>
      <el-button :icon="Close" link @click="onClose">关闭 </el-button>
    </ul>
    <ul class="c-list-search">
      <el-space wrap style="flex: 1">
        <el-cascader
          v-model="state.withholding_agent_uid"
          :options="state.withholding_agent_data"
          :props="{ value: 'uid', label: 'name' }"
          style="width: 300px"
          placeholder="扣缴义务人"
          filterable
          clearable
          @change="onWithholdingAgentChange"
          @clear="
            delete state.params.withholding_agent_type;
            delete state.params.withholding_agent_id;
            delete state.withholding_agent_uid;
          "
        />
        <el-select
          v-model="state.params.tax_bureau_id"
          placeholder="税局"
          style="width: 300px"
        >
          <el-option
            v-for="item in state.taxbureauData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select
          v-model="state.params.customer_id"
          placeholder="所得项目"
          style="width: 200px"
        >
          <el-option
            v-for="item in state.incomeData"
            :key="item.id"
            :label="item.value + '(' + item.name + ')'"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="姓名、手机号、证件号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-checkbox
          v-model="state.params.status"
          label="仅显示未填写数据"
          :true-value="0"
          :false-value="-1"
          @change="onStatusChange"
          size="large"
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="c-list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column width="55" fixed @click.stop="">
            <template #header>
              <el-checkbox :value="-1" @change="onSelect" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onRowClick(row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            label="姓名"
            prop="name"
            sortable="name"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="手机号"
            prop="phone"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="证件类型"
            prop="idtype"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="证件号码"
            prop="idcard"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="所得类型"
            prop="d_tax_type_name"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="所得项目"
            prop="declare_item"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="填写状态"
            prop="calc_tax_month"
            sortable="calc_tax_month"
            :min-width="120"
            :formatter="$tab_TextFormat"
          >
            <template #default="{ row }">
              <template v-if="props.attached_type == 'mssd'">
                <text v-if="row.attached_mssd_status == 1" style="color: #080"
                  >已填写</text
                >
                <text v-else>未填写</text>
              </template>
              <template v-else-if="props.attached_type == 'jmse'">
                <text v-if="row.attached_jmse_status == 1" style="color: #080"
                  >已填写</text
                >
                <text v-else>未填写</text>
              </template>
              <template v-else-if="props.attached_type == 'syjkbx'">
                <text v-if="row.attached_syjkbx_status == 1" style="color: #080"
                  >已填写</text
                >
                <text v-else>未填写</text>
              </template>
              <template v-else-if="props.attached_type == 'syylbx'">
                <text v-if="row.attached_syylbx_status == 1" style="color: #080"
                  >已填写</text
                >
                <text v-else>未填写</text>
              </template>
              <template v-else-if="props.attached_type == 'zykcjze'">
                <text
                  v-if="row.attached_zykcjze_status == 1"
                  style="color: #080"
                  >已填写</text
                >
                <text v-else>未填写</text>
              </template>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            label="免税收入"
            prop="mssd"
            sortable="mssd"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="免税事项"
            prop="attached_data.jmsx"
            :min-width="120"
            :formatter="$tab_TextFormat"
          >
          </el-table-column>
          <el-table-column
            label="免税性质"
            prop="attached_data.jmsx"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="扣缴义务人"
            prop="withholding_agent_name"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="税局"
            prop="tax_bureau_name"
            :min-width="120"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                type="warning"
                link
                icon="Edit"
                @click="onLoadSecondary(row)"
                >编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <el-dialog
      v-model="state.showEdits"
      :title="`批量编辑${state.selectIds?.length}位员工的免税事项及性质`"
      width="50%"
      :close-on-click-modal="false"
      align-center
    >
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 16px;
          margin-top: 40px;
        "
      >
        <li style="white-space: nowrap">免税事项及性质</li>
        <el-cascader
          v-model="state.secondary_arr"
          :options="state.secondary_data"
          :props="{ value: 'name', label: 'name' }"
          style="flex: 1; margin-left: 10px"
          placeholder="请选择"
          filterable
          clearable
        />
      </div>
      <template #footer>
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            style="width: 150px"
            @click="onEditSubmits"
            size="large"
          >
            提交修改
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-model="state.showEdit"
      :title="`编辑员工${state.selectItem?.name}的免税事项及性质`"
      width="50%"
      :close-on-click-modal="false"
      align-center
    >
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 16px;
          margin-top: 40px;
        "
      >
        <li style="white-space: nowrap">免税事项及性质</li>
        <el-cascader
          v-model="state.secondary_arr"
          :options="state.secondary_data"
          :props="{ value: 'name', label: 'name' }"
          style="flex: 1; margin-left: 10px"
          placeholder="请选择"
          filterable
          clearable
        />
      </div>
      <template #footer>
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            style="width: 150px"
            @click="onEditSubmit"
            size="large"
          >
            提交修改
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_withholdingagent_supplier_select,
  data_taxbureau_select,
} from "@/http/data";
import { income_select, secondary_select } from "@/http/dictionary";
import {
  taxdeclare_getattachedlist,
  taxdeclare_editattached,
  taxdeclare_editattachedbatch,
} from "@/http/taxdeclare";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    tax_declare_id: Number,
    attached_type: String,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      selectItem: {},
      model: {},
      secondary_data: [],
      secondary_arr: [],
      selectIds: [],
    });
    onMounted(() => {
      state.params.tax_declare_id = props.tax_declare_id;
      state.params.attached_type = props.attached_type;

      onLoadWithholdingAgent();
      onLoadTaxBureau();
      onLoadIncome();
      onLoad();
    });

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_supplier_select().then((res) => {
        if (res.status == 200) {
          const { withholdingAgent, supplier } = res.data.data;
          state.withholding_agent_data = [
            {
              uid: 0,
              name: "扣缴义务人",
              children: withholdingAgent.list.map((m) => {
                return { uid: "k_" + m.id, ...m };
              }),
            },
            {
              uid: 1,
              name: "供应商",
              children: supplier.list.map((m) => {
                return { uid: "g_" + m.id, ...m };
              }),
            },
          ];
        }
      });
    };

    //选择扣缴义务人
    const onWithholdingAgentChange = (value) => {
      if (value.length == 2) {
        state.params.withholding_agent_type = value[0];
        state.params.withholding_agent_id = value[1].substring(2);
      }
    };

    //获取税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureauData = res.data.data?.list;
      });
    };

    //获取所得项目
    const onLoadIncome = () => {
      income_select().then((res) => {
        if (res.status == 200) state.incomeData = res.data.data;
      });
    };

    const onLoadSecondary = (item) => {
      secondary_select({
        fblx:
          props.attached_type == "mssd"
            ? "免税附表"
            : props.attached_type == "jmse"
            ? "减免附表"
            : "",
        sdlxfb:
          item.declare_type == 1
            ? "zhsdfb"
            : item.declare_type == 2
            ? "flsdfb"
            : item.declare_type == 3
            ? "fjmsdfb"
            : "",
        sdlxmc: item.declare_item,
      }).then((res) => {
        if (res.status == 200) {
          state.secondary_data = res.data.data?.list;
          state.showEdit = true;
          state.selectItem = item;
        }
      });
    };

    const onEditSubmit = () => {
      if (state.secondary_arr?.length < 2) {
        ElMessage.warning("请选择减免事项！");
        return false;
      }
      taxdeclare_editattached({
        tax_declare_id: props.tax_declare_id,
        attached_type: props.attached_type,
        id: state.selectItem?.id,
        jmsx: state.secondary_arr[0],
        jmxz: state.secondary_arr[1],
      }).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          state.showEdit = false;
          onLoad();
        }
      });
    };

    const onEditSubmits = () => {
      if (state.secondary_arr?.length < 2) {
        ElMessage.warning("请选择减免事项！");
        return false;
      }
      taxdeclare_editattachedbatch({
        tax_declare_id: props.tax_declare_id,
        data: state.selectIds.map((m) => {
          return {
            attached_type: props.attached_type,
            id: m,
            jmsx: state.secondary_arr[0],
            jmxz: state.secondary_arr[1],
          };
        }),
      }).then((res) => {
        if (res.status == 200) {
          ElMessage({
            type: "success",
            message: res.data.msg,
            dangerouslyUseHTMLString: true,
          });
          state.showEdits = false;
          onLoad();
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;

      taxdeclare_getattachedlist(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onStatusChange = (checked) => {
      if (checked === -1) delete state.params.status;
    };

    const onRowClick = (item) => {
      if (state.selectIds?.includes(item.id)) {
        state.selectIds = state.selectIds.filter((w) => w != item.id);
      } else state.selectIds.push(item.id);
    };

    const onSelect = (checked) => {
      if (checked) {
        state.selectIds = [
          ...state.selectIds,
          ...state.tableData
            .filter((w) => !state.selectIds.includes(w.id))
            .map((m) => m.id),
        ];
      } else {
        state.selectIds = state.selectIds.filter(
          (w) => !state.tableData.map((m) => m.id).includes(w)
        );
      }
    };

    const onClose = () => {
      emit("close");
    };

    return {
      props,
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onWithholdingAgentChange,
      onLoadSecondary,
      onEditSubmit,
      onStatusChange,
      onRowClick,
      onSelect,
      onClose,
      onEditSubmits,
    };
  },
};
</script>
<style></style>
